module.exports = __webpack_public_path__ + "assets/media/morning.2e7c9914.mp3";